import { inject, injectable } from '@patsnap/tahiti-core/shared/inversify';
import { UserInfoService } from '@telecom/shared/domain/permission';
import { getIsOversea } from '@telecom/shared/utils/environment';
import type { OnboardingEligibilityService } from '../onboarding-eligibility-service';

/** 统一限制 onboarding 仅对海外个人用户生效。 */
@injectable()
export class OnboardingEligibilityServiceImpl implements OnboardingEligibilityService {
    constructor(
        /** 提供当前账号的个人或企业租户判断。 */
        @inject(UserInfoService)
        private readonly _userInfoService: UserInfoService,
    ) {}

    /** 仅当部署区域为海外且当前账号为个人租户时允许启动 onboarding。 */
    isEligible(): boolean {
        return getIsOversea() && this._userInfoService.isPersonalTenant();
    }
}
